module.exports = __webpack_public_path__ + "static/img/70f8d71f956dc03201d54140dc5906a.f2b52b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/70f8d71f956dc03201d54140dc5906a.jpg
// module id = GfJJ
// module chunks = 3